var render = function render(){var _vm=this,_c=_vm._self._c;return _c('preloader-with-text-slides',{attrs:{"textSlides":_vm.textSlides},on:{"loaded":_vm.nextComponent}})
}
var staticRenderFns = []

export { render, staticRenderFns }